import { render, staticRenderFns } from "./finance-detail.vue?vue&type=template&id=2cdd698a&scoped=true&"
import script from "./finance-detail.vue?vue&type=script&lang=js&"
export * from "./finance-detail.vue?vue&type=script&lang=js&"
import style0 from "./finance-detail.vue?vue&type=style&index=0&id=2cdd698a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd698a",
  null
  
)

export default component.exports